import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { SapEccLinkedService } from 'app/model/linkedservice/sap-ecc.linkedservice';
import { SapEccCopySource } from 'app/model/pipeline/copysource/sap-ecc.copysource';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';

export const sapEccMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(SapEccLinkedService).name,
    displayName: stringResources.SapEcc_DisplayText,
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-sap_ecc'
    },
    tableNameAlias: 'path',
    isFirstClass: true,
    copySinkTypes: [],
    copySourceTypes: [Metamodel.modelFor(SapEccCopySource).name],
    category: ['ServicesApps'],
    supportDatasetV2: true,
    onetimeQueryTemplate: '',
    // eslint-disable-next-line max-len
    timedQueryTemplate: '$filter=<<columnName>> ge datetime\'@{formatDateTime(pipeline().parameters.windowStart, \'yyyy-MM-ddTHH:mm:ssZ\' )}\' \nand <<columnName>> lt datetime\'@{formatDateTime(pipeline().parameters.windowEnd, \'yyyy-MM-ddTHH:mm:ssZ\' )}\'',
    deltaLoadQueryTemplate: `$filter=<<columnName>> ge @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
        json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue,
        concat('datetime''', formatDateTime(json(item().DataLoadingBehaviorSettings).watermarkColumnStartValue, 'yyyy-MM-ddTHH:mm:ssZ'), ''''))}
        and <<columnName>> lt @{if(contains(json(item().DataLoadingBehaviorSettings).watermarkColumnType, 'Int'),
        activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue,
        concat('datetime''', formatDateTime(activity('GetMaxWatermarkValue').output.firstRow.CurrentMaxWaterMarkColumnValue, 'yyyy-MM-ddTHH:mm:ssZ'), ''''))}`,
    controls: [
        {
            type: 'textbox',
            bind: 'url',
            label: stringResources.ModelName_Url,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            enableAKVParameterization: true,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.SapEcc_DisplayText),
                stringResources.ModelName_Password)
        }
    ]
};
